import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import Customs from "../../assets/customs.jpg";

const CustomsClearance = () => {
  return (
    <div>
      <Helmet>
        <title>Customs Clearance | Trans World Shipping</title>
        <meta
          name="description"
          content="Get expert customs clearance services with Trans World Shipping."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/customs-clearance"
        />
      </Helmet>

      <TheCustomsClearance>
        <div className="customs-hero">
          <img src={Customs} alt="Customs Clearance" />
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Customs Clearance</h1>
            <p>Expert brokerage services at all major U.S. ports nationwide</p>
          </div>
        </div>

        <div className="customs-container">
          <div className="intro-section">
            <p>
              Our brokerage division and their certified CHB members and
              associates provide Customs Clearance (remote) at all major U.S.
              ports nationwide.
            </p>
          </div>

          <div className="ior-section">
            <p>
              If you import goods and products, and you are acting as the IOR
              (Importer of Record), you are ultimately responsible for the
              correct tariff classifications.
            </p>
          </div>

          <div className="assistance-section">
            <p>
              We can assist you in identifying the proper customs code(s)
              applicable for your product(s) in order to comply with tariff
              rules and regulations.
            </p>
          </div>

          <div className="isf-section">
            <p>
              For 10+2 filings, please download the following forms in order to
              establish your ISF account.
            </p>
          </div>

          <div className="tracking-section">
            <p>
              Your international exports to Port(s) of entry and/or DDU/DDP
              deliveries to your client's facilities worldwide are handled
              cost-effectively, and are monitored daily for accurate processing
              through our tracking system.
            </p>
          </div>

          <div className="support-section">
            <p>
              Please call your personally assigned team member for latest
              updates and news releases. We are ready to assist you through the
              Transworld LIVE Hot Line.
            </p>
          </div>
        </div>
      </TheCustomsClearance>
    </div>
  );
};

const TheCustomsClearance = styled.div`
  width: 100%;
  background: #ffffff;

  .customs-hero {
    position: relative;
    width: 100%;
    height: 45vh;
    min-height: 350px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(11, 30, 51, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .customs-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
    }
  }

  .ior-section,
  .assistance-section,
  .isf-section,
  .tracking-section {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .support-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #d4af37;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 900px) {
    .customs-hero {
      height: 40vh;
      min-height: 300px;

      .hero-content h1 {
        font-size: 2.5rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .customs-container {
      padding: 3rem 1.5rem;
    }

    .intro-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .customs-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }
    }

    .customs-container {
      padding: 2rem 1rem;
    }

    .intro-section,
    .ior-section,
    .assistance-section,
    .isf-section,
    .tracking-section,
    .support-section {
      padding: 1.25rem;
    }
  }

  @media screen and (max-width: 600px) {
    .customs-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .intro-section p,
    .ior-section p,
    .assistance-section p,
    .isf-section p,
    .tracking-section p,
    .support-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .customs-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .customs-hero .hero-content p {
      font-size: 0.9rem;
    }
  }
`;

export default CustomsClearance;
